class CartRecommendations extends HTMLElement {

	#limit;
	#section;
	#intent;

	constructor(){
		super();
		this.#limit = this.dataset.limit;
		this.#section = this.dataset.section;
		this.#intent = this.dataset.intent || 'related';
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.#section}&product_id=${cartItems[0].dataset.productId}&limit=${this.#limit}&intent=${this.#intent}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          }
				})
				.catch(e=>{
					console.warn(e);
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);
